export enum EnPersonType {
    responsible = 'responsible',
    professional = 'professional',
    educator = 'educator'
}
